import GateButton from "@pathwright/ui/src/components/button/GateButton"
import PropTypes from "prop-types"
import "./ManageContentBlank.css"

const ManageContentOption = ({ icon, title, prompt, method, onSelect }) => (
  <GateButton
    icon={icon}
    line1={title}
    line2={prompt}
    onClick={onSelect.bind(undefined, method)}
  />
)

const ManageContentBlank = ({ prompt, methods, onSelectMethod }) => (
  <div className="ManageContent__Blank">
    <h1 className="ManageContent__BlankPrompt">{prompt}</h1>
    <div className="ManageContent__BlankOptions">
      {(() => {
        const result = []

        for (let key in methods) {
          const value = methods[key]
          if (value) {
            result.push(
              <ManageContentOption
                key={key}
                method={key}
                icon={value.icon}
                title={value.title}
                prompt={value.prompt}
                onSelect={onSelectMethod}
              />
            )
          }
        }

        return result
      })()}
    </div>
  </div>
)

ManageContentBlank.displayName = "ManageContentBlank"
ManageContentBlank.propTypes = {
  prompt: PropTypes.string.isRequired,
  methods: PropTypes.objectOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      prompt: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  onSelectMethod: PropTypes.func.isRequired
}

export default ManageContentBlank
